import styled from 'styled-components'

export const HeaderRowContainer = styled.div`
  width: 100%;
  position: sticky;
  z-index: 1001;
  background-color: transparent;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  padding: 0.5rem 1rem;
  gap: 1rem;
  align-items: center;

  .controls-section {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
  }
`
